import { BaseObject } from "../core/BaseObject";
import { ServiceCenterEmployee } from "./service-center-employee";

export class ServiceCenterDto extends BaseObject {
	serviceCenterId: number;
	name: string;
	inn: string;
	phone: string;
	email: string;
	address: string;
	latitude?: number;
	longitude?: number;
	serviceCenterTypeId: number;
	skipInventory: boolean;
	parentServiceCenterId: number;
	inventoryResponsibleUserId: number;
	employees: ServiceCenterEmployee[] = [];
}
